export async function apiFetch(path: string, init: RequestInit = {}) {
  const headers = new Headers(init.headers || {});
  // Only set JSON content-type for non-FormData bodies (FormData needs browser-managed boundary)
  if (!headers.has('content-type') && init.body && !(init.body instanceof FormData)) {
    headers.set('content-type', 'application/json');
  }
  return fetch(path, { ...init, headers });
}
